import React, {Component} from 'react';
import SelectField from 'material-ui/SelectField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import CircularProgress from 'material-ui/CircularProgress';

import TermsOfService from "./TermsOfService";
import DataStore from "../../../api/DataStore";
import api from '../../../api/api'
import Tracker from '../../common/Tracker';

import styles from "../styles";

import '../../../css/SurveyForm.css';

const CATEGORY = "locator survey";

class SurveyForm extends Component {

    constructor(props) {
        super(props);

        this.dataStore = new DataStore();
        this.state = {
            loading: true,
            survey: null,
            answers: {},
            errors: {},
            showTos: false
        }
    }

    componentWillMount() {
        Tracker.trackPageView('/locator/survey');

        // console.log("fetching survey questions");
        api.getSurveyQuestions((survey) => {
            // console.log("got 'em");
            this.setState({
                loading: false,
                survey: survey
            });
        })
    }

    onSelectChange = (surveyKey, resets, option) => {
        Tracker.trackEvent(CATEGORY, "select change", surveyKey, "");

        this.setState((state) => {
            let answers = state.answers;
            answers[surveyKey] = option;

            if (resets) {
                resets.forEach((resetKey) => {
                    answers[resetKey] = null;
                });
            }

            return {answers: answers};
        })
    }

    onContinueClick = () => {
        var errors = {};
        var keys = ["who","what","why"];
        keys.forEach((key) => {
            if (!this.state.answers[key]) {
                errors[key] = "Please choose an option";
            }
        });
        this.setState({errors: errors});

        if (!Object.keys(errors).length) {
            Tracker.trackEvent(CATEGORY, "continue click", "complete", "");
            this.dataStore.saveUserSurvey(this.state.answers);
            this.props.onSurveyComplete(this.state.answers);
        } else {
            Tracker.trackEvent(CATEGORY, "continue click", "incomplete", "");
        }
    }

    toggleTos = () => {
        Tracker.trackEvent(CATEGORY, "toggle tos", this.state.showTos ? "hide" : "show", "");
        this.setState((state) => {
            return {
                showTos: !state.showTos
            };
        });
    }

    render() {
        return (
            <div>
                <div className="locator-survey-form-header">
                    <div className="locator-survey-form-header-title">
                        Get Started
                    </div>
                    <div className="locator-survey-form-header-subtitle">
                        Before accessing the Infusion Locator tool, we need to know just a little bit about you. This information will help us improve our locator tool to better serve you.
                    </div>
                </div>
                {this.state.loading ?
                    <div style={{display: "flex", justifyContent: "center", marginTop: "50px"}}>
                        <CircularProgress size={50} />
                    </div>
                    :
                    <div className="locator-survey-form-content">
                        <SurveyQuestion
                            hintText="I am a..."
                            parent={this.state.survey}
                            surveyKey="who"
                            resetsKeys={["what","why"]}
                            onChange={this.onSelectChange}
                            answers={this.state.answers}
                            errors={this.state.errors}  />
                        <SurveyQuestion
                            hintText="Looking for..."
                            parent={this.state.answers.who}
                            surveyKey="what"
                            resetsKeys={["why"]}
                            onChange={this.onSelectChange}
                            answers={this.state.answers}
                            errors={this.state.errors} />
                        <SurveyQuestion
                            hintText="Because..."
                            parent={this.state.answers.what}
                            menuItemStyle={{fontSize: "14px"}}
                            surveyKey="why"
                            onChange={this.onSelectChange}
                            answers={this.state.answers}
                            errors={this.state.errors} />

                        <div className="locator-survey-form-disclaimer-container">
                            <div className="locator-survey-form-disclaimer-container-label">
                                By continuing you agree to our <FlatButton label="Terms of Service" labelStyle={{textTransform: "none", fontFamily: "Lato", fontSize: "14px", color: "#46bee2", paddingLeft: "5px", paddingRight: "5px"}} onClick={this.toggleTos} />
                            </div>
                            <div>
                                <RaisedButton
                                    label="Continue"
                                    backgroundColor="#53c9e8"
                                    labelStyle={{fontFamily: "Oswald", fontSize: "18px", color: "white"}}
                                    onClick={this.onContinueClick} />
                            </div>
                        </div>
                    </div>
                }
                <TermsOfService open={this.state.showTos} toggleTos={this.toggleTos} />
            </div>
        )
    }
}

class SurveyQuestion extends Component {

    getOptions() {
        if (this.props.parent) {
            return this.props.parent[this.props.surveyKey];
        }
        return [];
    }

    getValue() {
        let answer = this.props.answers[this.props.surveyKey];
        if (answer) {
            return answer.label;
        }
        return "";
    }

    onChange = (event, index, value) => {
        // console.log("onChange");
        let option = this.getOptions()[index];
        this.props.onChange(this.props.surveyKey, this.props.resetsKeys, option);
    }

    render() {
        return (
            <SelectField
                style={{textSize: "10px"}}
                hintText={this.props.hintText}
                floatingLabelText={this.props.hintText}
                floatingLabelFixed={false}
                menuItemStyle={this.props.menuItemStyle}
                onChange={this.onChange}
                disabled={!this.getOptions().length}
                fullWidth={true}
                floatingLabelStyle={styles.floatingLabelStyle}
                underlineDisabledStyle={styles.underlineStyle}
                errorText={this.props.errors[this.props.surveyKey]}
                value={this.getValue()}>
                {this.getOptions().map((option, index) => {
                    // console.log(option);
                    return (
                        <MenuItem
                            value={option.label}
                            primaryText={option.label}
                            style={{fontSize: "14px"}}
                            key={"option-" + this.props.surveyKey + "-" + index} />
                    )
                })}
            </SelectField>
        )
    }
}

export default SurveyForm;



// WEBPACK FOOTER //
// ./src/components/locator/survey/SurveyForm.js